const isExternal = (string: string) => {
  return /(http(s?)):\/\//i.test(string);
};

export default isExternal;
